import DeleteRounded from "@mui/icons-material/DeleteRounded";
import { Box, Button } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  selectedCount: number;
  onDownload: () => void;
  onDelete: () => void;
  onMerge?: () => void;
  disabled?: boolean;
}

export function BulkActionBar({ selectedCount, onDownload, onDelete, onMerge, disabled }: Props) {
  const { t } = useTranslation();

  if (selectedCount < 1) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", pt: 1, justifyContent: "flex-end" }}>
      {onMerge && (
        <Button variant="outlined" size="small" onClick={onMerge} disabled={!!disabled || selectedCount < 2}>
          {t("dropzone.fileList.bulkMerge")}
        </Button>
      )}
      <Button variant="outlined" size="small" onClick={onDownload} disabled={disabled}>
        {t("dropzone.fileList.bulkDownload")}
      </Button>
      <Button
        variant="outlined"
        size="small"
        color="error"
        onClick={onDelete}
        disabled={disabled}
        aria-label={t("dropzone.fileList.bulkDelete")}
        sx={{ minWidth: 0, width: "40px" }}
      >
        <DeleteRounded />
      </Button>
    </Box>
  );
}
